import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ds from "../../../Services/DataServices";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { Card, Row, Col, Switch, Spin, message } from "antd";
import IntlMessages from "../../../util/IntlMessages";
import { faThLarge } from "@fortawesome/free-solid-svg-icons";
import { notAllowMsgCheck, setCommonConfigs } from "../../../appRedux/actions";
import { STORE_CREDIT } from "../../../constants/Pages";
import {
  READ,
  CREATE,
  UPDATE,
  DELETE,
} from "../../../constants/RightsAndPermissions";
import NotAllowedComponent from "../../../components/NotAllowedComponent";

const StoreCredit = () => {
  const dispatch = useDispatch();

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );

  const [storeCreditConfig, setstoreCreditConfig] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(true); // change state
  const [getCurrSymbol, setCurrSymbol] = useState("");
  const [getShortCurr, setShortCurr] = useState("");
  const [getIsDisable, setIsDisable] = useState(true);
  const [getIsAllowRead, setIsAllowRead] = useState(false);
  const [getAccessLoading, setAccessLoading] = useState(true);
  const [getRights, setRights] = useState([]);
  const [getPermissions, setPermissions] = useState([]);

  useEffect(() => {
    dispatch(setCommonConfigs(STORE_CREDIT));
    ds.getStoreCreditConfiguration("", BEHAVIOUR_TYPE.GET)
      .then((res) => {
        res === "True"
          ? setstoreCreditConfig(true)
          : setstoreCreditConfig(false);
        setConfirmLoading(false);
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setConfirmLoading(false);
      });
  }, []);

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting;
    let rites = [];
    let permissions = [];
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig
    ) {
      if (commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission) {
        if (
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
            .rites &&
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
            .length > 0
        ) {
          rites =
            commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
              .rites;
          setRights(rites);
        }
        if (
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
            .permission &&
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
            .permission.length > 0
        ) {
          permissions =
            commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
              .rites;
          setPermissions(permissions);
        }
      }

      //curr
      if (commonData.storeCommonConfigs.storeConfig.currencyData) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData;
        setCurrSymbol(currencyData.currencySymbol);
        setShortCurr(currencyData.currencyCode);
      }
    }

    if (rites.length > 0) {
      if (rites.filter((a) => a == READ).length > 0) {
        setIsAllowRead(true);
      }
      if (rites.filter((a) => a == CREATE || a == UPDATE).length > 0) {
        setIsDisable(false);
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false);
    }
  }, [getReduxCommonSetting]);

  const updateStoreConfig = (e) => {
    setConfirmLoading(true);
    ds.updateStoreConfiguration({ IsEnable: e }, BEHAVIOUR_TYPE.UPDATE)
      .then((res) => {
        ds.getStoreCreditConfiguration("", BEHAVIOUR_TYPE.GET)
          .then((res) => {
            res === "True"
              ? setstoreCreditConfig(true)
              : setstoreCreditConfig(false);

            setConfirmLoading(false);
          })
          .catch((e) => {
        notAllowMsgCheck(e);
            message.warn("Server down, try again later");
            setConfirmLoading(false);
          });
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        message.warn("Server down, try again later");
        setConfirmLoading(false);
      });
  };

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id="sell.cashlisting.cashloading" />}
      spinning={confirmLoading}
      size="large"
    >
      <div className="Content-wrapper">
        
          <Row>
            <Col md={24}>
              <h1 className="mb-0">
                <IntlMessages id="setup.storecreditTitle" />
              </h1>
            </Col>
            <Col md={24}>
            <p className="custom-storeadd-head">
                <IntlMessages id="setup.storecredit.helpDescription" />
              </p>
              </Col>
          </Row>

          
     
          <Card className="storecredit-card">
            <Row>
              <Col md={8}>
              <h2 class="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                  <IntlMessages id="setup.storecredit.enableStoreCredit" />
                </h2>
              </Col>
              <Col md={16}>
                <Switch
                  checked={storeCreditConfig}
                  onChange={updateStoreConfig}
                  size="default"
                  disabled={getIsDisable}
                />
                <p className="custom-storeadd-head mb-0">
                  <IntlMessages id="setup.storecredit.enableStoreCreditText" />
                </p>
                <p>
                  <IntlMessages id="setup.storecredit.enableStoreCreditSubText" />
                </p>
              </Col>
            </Row>
          </Card>

        
      </div>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  );
};

export default StoreCredit;
